export enum LightModernSidebarVariantType {
  Tinted = 'tinted',
  Contrast = 'contrast',
}
